// Maps the app's react-intl locale code to a BCP-47 tag so native Date
// formatting (toLocaleDateString/toLocaleTimeString/toLocaleString) renders
// weekday and month names in that language's own script, instead of always
// falling back to English.
const LOCALE_TAG_MAP = {
  en: 'en-US',
  hi: 'hi-IN',
  ta: 'ta-IN',
  ml: 'ml-IN',
  kn: 'kn-IN'
};

export const getDateLocaleTag = (locale) => LOCALE_TAG_MAP[locale] || 'en-US';
